import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/invoicePaymentMethods', request, cancelToken)
}

export {get}
